module.exports = __webpack_public_path__ + "static/img/hypno-boy.cd44695.gif";


//////////////////
// WEBPACK FOOTER
// ./src/SVG-filer/hypno-boy.gif
// module id = 2d2e
// module chunks = 1